import './BossWindow.css';
import './Cpu.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {isMobile} from 'react-device-detect';
import {BattleBg} from "../../../services/BattleBg";
import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import {sendUrlParams} from "../../../utils/sendUrlParams";

function BossWindowComponent() {

    const {user, tutorial, cpuStory} = useTypedSelector(state => state.auth);
    const {setCpuStory, setTutorial, setSystemMessage, setBattleBg, setRoute} = useActions();

    /*
                                 bossWindowVisible,
                                 setBossWindowVisible,
                                 storyCpu,
                                 setStoryWindowVisible
     */

    const story = cpuStory.story;

    let rootCpu1Classes = 'map-popup-cpu-image ' + 'cpu-' + story.cpu1.id;
    let rootCpu2Classes = 'map-popup-cpu-image' + ' cpu-' + story.cpu2.id;
    let rootCpu3Classes = 'map-popup-cpu-image ' + 'cpu-' + story.cpu3.id;

    const rootClasses = ['main-popup-container', 'boss-window-popup', 'map-popup-active\''];


    const tutorialAction = function () {
        if (tutorial.step === 'BossWindow30') {
            tutorial.step = 'BossWindow30-skip-comics';
            setTutorial(tutorial);
        }
        if (tutorial.step === 'BossWindowSecond82') {
            tutorial.isActive = false;
            setTutorial(tutorial);
        }
        if (tutorial.step === 'BossWindowSecond84') {
            tutorial.isActive = false;
            setTutorial(tutorial);
        }
    }

    let isActiveToPlay = true;

    if (story.level > user.level) {
        isActiveToPlay = false;
    }

    let cpu3Name = story.name;
    if (story.cpu3Name !== undefined) {
        cpu3Name = story.cpu3Name;
    }

    let cpuOneGrey = ' defaultButtonAnimation_5 ';
    if (!isActiveToPlay || tutorial.step === 'BossWindowSecond82' || tutorial.step === 'BossWindowSecond84') {
        cpuOneGrey = ' map-popup-grey ';
    }

    let cpuTwoGrey = '';
    if (tutorial.step === 'BossWindowSecond82') {
        cpuTwoGrey = ' defaultButtonAnimation_5 ';
    }
    if (!user.maps.find(element => element === story.cpu1.id) || tutorial.step === 'BossWindowSecond84') {
        cpuTwoGrey = ' map-popup-grey';
    }

    let cpuThreeGrey = '';
    if (tutorial.step === 'BossWindowSecond84') {
        cpuThreeGrey = ' defaultButtonAnimation_5 ';
    }
    if (!user.maps.find(element => element === story.cpu2.id)) {
        cpuThreeGrey = ' map-popup-grey';
    }


    const play = (cpuId, cpuNumber) => {

        if (user.deck.total_amount < 50) {
            setSystemMessage({
                isVisible: true,
                type: 'info',
                text: 'The deck must contain at least 50 cards',
                action: null
            })
            return;
        }

        setBattleBg(BattleBg.choiceBg(cpuId));

        if (!isActiveToPlay || cpuStory.isPromo === true) {
            return;
        }

        setCpuStory({
            story: cpuStory.story,
            cpuId: cpuId,
            cpuNumber: cpuNumber,
            action: 'before',
            isPromo: cpuStory.isPromo
        });

        tutorialAction();

        setRoute('story');
    }

    let nameClass = 'map-popup-caption-text';
    let cpuNameClass = 'map-popup-cpu-name-text';
    if (isMobile) {
        nameClass = 'map-popup-caption-text-Mobile';
        cpuNameClass = 'map-popup-cpu-name-text-Mobile';
    }

    let text = "Required chapter " + (story.level - 1);

console.log(story.cpu4);
    return (
        <div className={rootClasses.join(' ')}>
            <ButtonCloseMainPopup/>

            <div className="map-popup-caption">
                <div className={nameClass}>{story.name}</div>
            </div>

            {isActiveToPlay ? (
                <div className="map-popup-text"><span
                    className="map-popup-text-chapter">Chapter {story.level}.</span> {story.text}
                </div>
            ) : (
                <div className="map-popup-text-level">{text}
                </div>
            )

            }

            {(!cpuStory.isPromo) ?
                <div className="map-popup-cpu-container">
                    <div className="map-popup-cpu">
                        <div className="map-popup-cpu-name">
                            <div className={cpuNameClass}>{story.cpu1Name}</div>
                        </div>
                        <div className={rootCpu1Classes + cpuOneGrey}></div>
                        <div
                            className={
                                `map-popup-cpu-button-play${cpuOneGrey}`
                            }
                            onClick={() => {
                                if (tutorial.step !== 'BossWindowSecond82') {
                                    play(story.cpu1.id, 'cpu1');
                                }
                            }}
                        ></div>

                    </div>


                    <div
                        className={'map-popup-cpu'}
                    >
                        <div className="map-popup-cpu-name">
                            <div className={cpuNameClass}>{story.cpu2Name}</div>
                        </div>
                        <div className={rootCpu2Classes + cpuTwoGrey}></div>
                        <div
                            className={`map-popup-cpu-button-play${cpuTwoGrey}`}
                            onClick={() => {
                                if (user.maps.find((element) => element === story.cpu1.id)) {
                                    play(story.cpu2.id, 'cpu2');
                                }
                            }}
                        ></div>
                    </div>


                    <div
                        className={'map-popup-cpu '}>
                        <div className="map-popup-cpu-name">
                            <div className={cpuNameClass}>{cpu3Name}</div>
                        </div>
                        <div className={rootCpu3Classes + cpuThreeGrey}></div>
                        <div className={'map-popup-cpu-button-play' + cpuThreeGrey}
                             onClick={() => {
                                 if (user.maps.find(element => element === story.cpu2.id)) {
                                     play(story.cpu3.id, 'cpu3');
                                 }
                             }}
                        ></div>
                    </div>

                    {(user.level > 3 && story.cpu4 && (user.maps.find(element => element === story.cpu3.id))) ?
                        <div
                            className={'map-popup-cpu '}>
                            <div className="map-popup-cpu-name">
                                <div className={cpuNameClass}>Bonus Level(optional)</div>
                            </div>
                            {(user.maps.find(element => element === story.cpu4.id)) ?
                                <div className={'map-popup-cpu-image cpu-bl'}></div>
                                :
                                <div className={'map-popup-cpu-image cpu-bl-empty'}></div>
                            }
                            <div className={'map-popup-cpu-button-play'}
                                 onClick={() => {
                                     if (user.maps.find(element => element === story.cpu3.id)) {
                                         play(story.cpu4.id, 'cpu4');
                                     }
                                 }}
                            ></div>
                        </div>
                        : <div></div>
                    }

                </div>
                : <div></div>
            }
        </div>
    );
}

export default BossWindowComponent;
